import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'

import { UploadDocumentType, UserDocumentCategoryIdentifier } from '@/constants'
import { useAppDispatch } from '@/utils/typeHelpers'
import { useReselector } from '@/utils/sharedHooks'
import { getUserDocumentsByCategoryInternalName } from '@/featuresV1/UserDocuments/userDocuments.selector'
import {
  IAdditionalTrackingProperties,
  useDocumentUpload,
} from '@/components/documents/upload/hooks/useDocumentUpload'
import { destroySingleUserDocument } from '@/featuresV1/UserDocuments/userDocuments.slice'

import { TypographyStyles, TextColors } from '@/styles'
import { DocumentUploadDialog, Icon, Link, List, Popup, Text } from '@/ui'

interface IUploadItem {
  additionalTrackingProperties: IAdditionalTrackingProperties
  children?: React.ReactNode
  documentCategory: UserDocumentCategoryIdentifier
  documentType?: UploadDocumentType
  label: string
  popUpContent?: React.ReactNode
  uploadProps?: {
    year?: string
  }
  onUploadSuccess?: () => void
}

// TBD potentially reusabled/replacement for FileUploadFormInput comp
export const UploadItem = ({
  additionalTrackingProperties,
  children,
  documentCategory,
  documentType = UploadDocumentType.TAX,
  label,
  popUpContent,
  uploadProps = {},
  onUploadSuccess,
}: IUploadItem) => {
  const dispatch = useAppDispatch()

  const { uploadDocuments, isUploading } = useDocumentUpload({
    documentCategory,
    documentType,
    additionalTrackingProperties,
    onUploadSuccess,
    ...uploadProps,
  })

  const uploadedDocuments = useReselector(
    getUserDocumentsByCategoryInternalName,
    documentCategory
  )

  return (
    <div>
      <DocumentUploadDialog
        label={label}
        afterLabel={popUpContent && <Popup content={popUpContent} />}
        cardTitle={label}
        onUpload={uploadDocuments}
        isUploadDisabled={isUploading}
        variant="secondary"
        hasTrigger
        classNameBody="overflow-visible"
      >
        <DocumentUploadDialog.CardContent>
          {children}
        </DocumentUploadDialog.CardContent>
      </DocumentUploadDialog>

      <List>
        {uploadedDocuments.map((doc) => (
          <List.Item key={doc.id} className="flex items-center mb-2">
            {doc?.signedUrl ? (
              <Link
                href={doc.signedUrl}
                variant="primary"
                color={TextColors.MUTED}
              >
                {doc?.fileDescription}
              </Link>
            ) : (
              <Text variant={TypographyStyles.BODY_SM} color={TextColors.MUTED}>
                {doc?.fileDescription}
              </Text>
            )}

            <Icon
              icon={regular('trash-can')}
              onClick={() => dispatch(destroySingleUserDocument(doc.id))}
              className="ml-2 cursor-pointer"
              color="green"
            />
          </List.Item>
        ))}
      </List>
    </div>
  )
}
